export enum OffersActionTypes {
  API_RESPONSE_SUCCESS = "@@offers/API_RESPONSE_SUCCESS",
  API_RESPONSE_ERROR = "@@offers/API_RESPONSE_ERROR",

  GET_OFFERS = "@@offers/GET_OFFERS",
  UPDATE_OFFERS = "@@offers/UPDATE_OFFERS",
  ADD_OFFERS = "@@offers/ADD_OFFERS",
  DELETE_OFFERS = "@@offers/DELETE_OFFERS",
  CLEAR_ERROR = "@@offers/CLEAR_ERROR",
}
